/**
 * Creates an identity function with some type constraint, such that when the produced function is invoked, it returns its input, but typed as itself.
 * This is useful if you wish to define some object `as const`, while still enforcing a level of type safty on the structure of the object.
 *
 * @example
 * type Pet = {
 *  species: 'cat' | 'dog',
 *  age: number
 * }
 *
 * const definePets = createIdenFn<Record<string, Pet>>();
 * const pets = definePets({
 *   'joe': {
 *     species: 'cat',
 *     age: 5
 *   },
 *   'jim': {
 *     species: 'dog',
 *     age: 2
 *   }
 * })
 *
 * const PetNames = keyof typeof pets; // 'joe' | 'jim'
 */
export function createIdenFn() {
    return function (def) {
        return def;
    };
}
